/**
 * @voltxampere/ui — Power transformer 220V:12V variant (Sprint 44-6, placeholder)
 *
 * PLACEHOLDER. Step-down güç transformer'ı — şebeke 220V AC → 12V
 * AC sekonder. Tek primary winding `inductor` üzerinden modellenir;
 * secondary winding + N₂/N₁ = 12/220 ≈ 0.0545 turns ratio +
 * mutual inductance Sprint 47+'da (coupled inductor stamp).
 *
 * Reference: Generic linear power transformer — Hammond 187C12,
 * Talema TZ-30/12. Primary 220 V AC / 50 Hz, secondary 12 V AC,
 * 30-50 VA. Linear AC adapter, lab bench supply, audio amplifier
 * raw rail.
 *
 * Engine zero-diff invariant honored — canonical `inductor` engine
 * type via schemaType.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { inductor } from "../inductor.js";
export const transformerPower220to12 = {
    id: "transformer-power-220-12",
    nameTr: "Güç Transformer 220V:12V (placeholder, primary)",
    nameEn: "Power Transformer 220V:12V (placeholder, primary)",
    shortcut: "L",
    category: "passive",
    viewBox: inductor.viewBox,
    terminals: inductor.terminals,
    defaultLabel: "T",
    defaultValue: "PWR-220:12",
    schemaType: "inductor",
    defaultParams: { inductance: 5 },
    renderSVG: () => inductor.renderSVG(),
};
//# sourceMappingURL=transformer-power-220-12.js.map